import React from 'react';
import PropTypes from 'prop-types';
import '../css/EmailStyles.scss';
import { assetUrl } from '../config/asset-config';

const EmailPreviewTemplate = ({
    displayFont = {}, pageName = '', business = {}, currentProject = {}, emailLogo = '', emailMessage = '', ctaDesc = '', envelopeName = '', landingPage = {}, receipients = [], recipientIndex = 0, activeRecipient = receipients[recipientIndex] || {}, trans = {}, vrExampleVideo = {}, envelopePath = '', withFieldsMerged = () => { },
}) => {
    const emailTemplate = () => {
        if (currentProject.project_type.slug === 'video-request') {
            return 'video-request';
        }
        return currentProject.email_template.slug || 'classic';
    };

    const emailType = () => {
        if (currentProject.project_type.slug === 'video-request') {
            return 'video-request';
        }
        switch (currentProject.email_template.slug) {
            case 'simple':
                return 'video';
            case 'simple-animated':
                return 'animated';
            default:
                return 'envelope';
        }
    };

    const previewEmailMessage = () => {
        let text;
        if (emailMessage) {
            text = emailMessage;
        } else {
            return '';
        }

        const replacePairs = [
            ['<div>', '<p>'],
            ['<\/div>', '</p>'],
            ['<div-text-left>', '<p style="text-align: left; !important" align="left">'],
            ['<\/div-text-left>', '</p>'],
            ['<div-text-center>', '<p style="text-align: center; !important" align="center">'],
            ['<\/div-text-center>', '</p>'],
            ['<div-text-right>', '<p style="text-align: right; !important" align="right">'],
            ['<\/div-text-right>', '</p>'],
            ['<underline style="text-decoration: underline;">', '<span style="text-decoration: underline;">'],
            ['<\/underline>', '</span>'],
        ];

        replacePairs.forEach((pair) => {
            text = text.replace(new RegExp(pair[0], 'g'), pair[1]);
        });
        return text;
    };

    const logoStyles = () => {
        if (business.email_logo_width) {
            return {
                width: (business.email_logo_width * 100 / 600) + '%',
                maxWidth: (business.email_logo_width * 100 / 600) + '%',
                height: (business.email_logo_width * 100 / 600) + '%',
                maxHeight: (business.email_logo_width * 100 / 600) + '%',
            };
        }
    };

    const imageTextStyles = () => {
        let imageUrl;

        switch (emailType()) {
            case 'envelope':
                imageUrl = envelopePath + '/front-small.jpg';
                break;
            case 'video':
                imageUrl = activeRecipient.video_thumb ? activeRecipient.video_thumb : assetUrl('assets/img/video_email_example_plain_c.jpg');
                break;
            case 'animated':
                imageUrl = assetUrl('assets/img/animated_email_example.gif');
                break;
            default:
                break;
        }

        return {
            backgroundImage: 'url(' + imageUrl + ')',
        };
    };

    const barColor = () => (landingPage && landingPage.header_bkgd_color ? landingPage.header_bkgd_color : '#ffffff');

    const buttonColor = () => {
        const defaultButtonColor = currentProject.project_type.slug === 'video-request' ? '#0A2463' : '#000000';
        return landingPage && landingPage.button_color ? landingPage.button_color : defaultButtonColor;
    };

    const buttonTextColor = () => (landingPage && landingPage.button_text_color ? landingPage.button_text_color : '#ffffff');

    const unsubscribeTextColor = () => (business && business.unsubscribe_link_color ? business.unsubscribe_link_color : '#000000');

    const renderUnsubscribeText = () => {
        if (Object.keys(business).length === 0) {
            return (
                <p className="unsubscribe-text">
                    <a href="#" style={{ color: unsubscribeTextColor() }}>Unsubscribe here</a> to stop receiving emails from ThankView including thank you videos. Learn more about our <a href="#" style={{ color: unsubscribeTextColor() }}>privacy policy</a>.
                </p>
            );
        }

        if (Object.keys(business).length > 0 && Object.keys(trans).length > 0) {
            return (
                <p className="unsubscribe-text" dangerouslySetInnerHTML={{ __html: trans['unsubscribe-policy'] }}></p>
            );
        }

        if (business && business.disclaimer) {
            return (
                <p className="unsubscribe-text" dangerouslySetInnerHTML={{ __html: business.disclaimer }}></p>
            );
        }
    };

    const renderFullScreenOverlay = () => <div className="width-100 height-100 absolute" style={{ zIndex: 50, top: 0, left: 0 }}></div>;

    const renderEmailMessage = (isPlacementLeft = false) => (
        <div
            className={`font-size-14px ${isPlacementLeft ? 'text-align-left' : ''} width-90 margin-center`}
            dangerouslySetInnerHTML={{ __html: withFieldsMerged(previewEmailMessage(), activeRecipient) }}>
        </div>
    );

    const renderPreviewButton = () => (
        <span className="btn btn--small preview-button" align="center" style={{ backgroundColor: currentProject.button_color, color: buttonTextColor() }}>
            {currentProject.email_cta_text ? (
                <span>{withFieldsMerged(currentProject.email_cta_text, activeRecipient)}</span>
            ) : (
                <span>{currentProject.project_type.name === 'Endowment Reports' ? trans['view-report'] : trans['watch-video']}</span>
            )}
        </span>
    );

    const renderHr = () => barColor() === '#ffffff' && <hr />;

    const mergeFieldsInSubject = () => withFieldsMerged(currentProject.email_subject, activeRecipient);

    return (
        <>
            {
                currentProject.method.slug === 'text' && (
                    <div className={`content-wrapper relative margin-center margin-b-48px bg-white overflow-auto max-width-640px ${pageName === 'setup' ? 'margin-t-32px' : 'margin-t-88px md-margin-t-104px lg-margin-t-88px'}`}>
                        {renderFullScreenOverlay()}
                        <div className="sms-content flex flex-dir-col margin-t-16px pad-b-96px font-size-14px pad-l-24px pad-r-24px">
                            <div className={`text-bubble image-text pad-l-8px pad-r-8px margin-b-8px size-up delay-half ${emailType()}-text flex justify-content-center align-items-center`} style={imageTextStyles()}>
                                {
                                    emailType() === 'envelope' && <p className="font-white" style={{ color: currentProject.envelope.fontColor }}>
                                        {`${activeRecipient.name} ${activeRecipient.last_name}`}
                                    </p>
                                }
                            </div>

                            <div className="text-bubble gray-text relative bg-gray-90 pad-l-8px pad-r-8px margin-b-8px size-up delay-half">
                                {
                                    currentProject.project_type.name === 'Video Request'
                                        ? <p>
                                            {`${mergeFieldsInSubject()} This message is sent from ${withFieldsMerged(currentProject.email_from, activeRecipient)}.`} <br />Reply STOP to unsubscribe <span className="font-blue-48">{`https://thankview.com/${business.slug}/video/12fks-f9j2f-fj92-fsdf0`}</span>
                                        </p>
                                        : <p>
                                            {`${mergeFieldsInSubject()} Click the link to watch the video sent from ${withFieldsMerged(currentProject.email_from, activeRecipient)}.`} <br />Reply STOP to unsubscribe <span className="font-blue-48">{`https://thankview.com/${business.slug}/video/12fks-f9j2f-fj92-fsdf0`}</span>
                                        </p>
                                }
                            </div>

                            <div className="text-bubble blue-text relative bg-blue-90 pad-l-8px pad-r-8px margin-b-8px size-up delay-one">
                                <p>I love this video!</p>
                            </div>
                            <div className="text-bubble gray-text relative bg-gray-90 pad-l-8px pad-r-8px margin-b-16px size-up delay-two">
                                <p>{currentProject.sms_response || 'Here is where your text reply would go'}</p>
                            </div>
                        </div >
                    </div >
                )
            }

            {
                currentProject.method.slug !== 'text' && (
                    <div className={`content-wrapper relative margin-center margin-b-48px bg-white pad-l-24px pad-r-24px overflow-auto max-width-640px ${pageName === 'setup' ? 'margin-t-32px' : 'margin-t-88px md-margin-t-104px lg-margin-t-88px'}`} style={{ fontFamily: displayFont ? displayFont.name : '' }}>
                        {renderFullScreenOverlay()}
                        <div className="preview__email-header">
                            <h2 className="font-size-20px margin-t-8px margin-b-4px">{mergeFieldsInSubject()}</h2>
                            <hr className="border-color-gray-80 margin-t-4px margin-b-16px" />
                            <div>
                                <div className="preview__email-to-decoration inline-block float-left font-w-6 font-white font-size-20px text-align-center margin-r-8px">{(activeRecipient && activeRecipient.name) ? activeRecipient.name.charAt(0) : ''}</div>
                                <h3 className="preview__email-from margin-0px font-size-16px">{withFieldsMerged(currentProject.email_from, activeRecipient)}</h3>
                                <p className="preview__email-to margin-0px font-size-14px">To: {activeRecipient.email}</p>
                            </div>
                        </div>

                        {/* Envelope */}
                        {
                            emailTemplate() === 'classic' && (
                                <div id="envelope-email" className="email-content envelope-email margin-t-8px pad-b-96px">
                                    {renderEmailMessage()}
                                    <div className="width-100 text-align-center">
                                        {renderPreviewButton()}
                                    </div>
                                    <div className="relative">
                                        <img className="width-100 block envelope" src={envelopePath + '/front-small.jpg'} role="presentation" />
                                        <span className="name-label" align="center" style={{ color: currentProject.envelope.emailFontColor }} dangerouslySetInnerHTML={{ __html: envelopeName }} fit-text="true" project="currentProject" max-font="32" base-width="728"></span>
                                        <img className="width-100 block margin-center" style={{ maxWidth: 550 }} src={assetUrl('assets/img/card-shadow.png')} role="presentation" />
                                    </div>

                                    {renderUnsubscribeText()}
                                </div >
                            )
                        }

                        {/* Thumbnail of Video */}
                        {
                            emailTemplate() === 'simple' && (
                                <div className="email-content margin-t-8px pad-b-96px video-email">
                                    <div className="email-contents bg-white pad-b-8px pad-l-16px pad-r-16px margin-center text-align-center">
                                        <div className="logo-bar" style={{ backgroundColor: barColor() }}>
                                            <img className="block logo" src={emailLogo || ''} style={logoStyles()} />
                                        </div>
                                        {renderHr()}
                                        {renderEmailMessage(true)}
                                        {renderPreviewButton()}
                                        <div style={{
                                            position: 'relative', width: '91.5 %', margin: '0 auto', overflow: 'hidden',
                                        }}>
                                            <img className="width-100 block" src={activeRecipient.video_thumb ? activeRecipient.video_thumb : assetUrl('assets/img/video_email_example_plain_c.jpg')} option="image" />
                                            {
                                                activeRecipient && activeRecipient.video_thumb && (
                                                    <>
                                                        <img className="watch-bar width-100 block" src={assetUrl(`assets/img/email/watch_bar_new_${currentProject.locale}.png`)} role="presentation" />
                                                        <div className="play-button" style={{ backgroundColor: buttonColor() }}>
                                                            <img className="block" src={assetUrl('assets/img/email/play_button.png')} alt="Play Button" />
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                        {renderUnsubscribeText()}
                                    </div>
                                </div >
                            )
                        }

                        {/* Animated */}
                        {
                            emailTemplate() === 'simple-animated' && (
                                <div className="email-content margin-t-8px pad-b-96px animated-email">
                                    <div className="email-contents bg-white pad-b-8px pad-l-16px pad-r-16px margin-center text-align-center">
                                        <div className="logo-bar" style={{ backgroundColor: barColor() }}>
                                            <img className="logo" src={emailLogo || ''} style={logoStyles()} />
                                        </div>
                                        {renderHr()}
                                        {renderEmailMessage(true)}
                                        {renderPreviewButton()}
                                        <div style={{ position: 'relative' }}>
                                            <img className="block" style={{ margin: '0 auto', width: '91.5%' }} src={assetUrl('assets/img/animated_email_example.gif')} alt="Animated Email Example" />
                                        </div>
                                        {renderUnsubscribeText()}
                                    </div >
                                </div >
                            )
                        }

                        {/* Video Request */}
                        {
                            emailTemplate() === 'video-request' && (
                                <div className="email-content margin-t-8px pad-b-96px emailType video-request-email">
                                    <div className="email-contents bg-white pad-b-8px margin-center text-align-center">
                                        <div className="logo-bar" style={{ backgroundColor: barColor() }}>
                                            <img className="logo" src={emailLogo || ''} style={logoStyles()} />
                                        </div>
                                        {renderHr()}

                                        {
                                            !currentProject.due_date && trans && !business.hide_video_request_email_copy && <p className="pad-l-16px pad-r-16px" dangerouslySetInnerHTML={{ __html: trans['request-bz'] }}></p>
                                        }

                                        {
                                            currentProject.due_date && trans && !business.hide_video_request_email_copy && <p className="pad-l-16px pad-r-16px" dangerouslySetInnerHTML={{ __html: trans['request-bz-due'] }}></p>
                                        }

                                        <p className="instructions tv-rich-text-content text-align-left line-height-1_5 pad-l-16px pad-r-16px" style={{ margin: '30px 0' }} dangerouslySetInnerHTML={{ __html: withFieldsMerged(ctaDesc, activeRecipient) }}></p>

                                        {
                                            currentProject.vr_example_video_id && vrExampleVideo && <div className="example-video-thumbnail" style={{ backgroundImage: `url(${vrExampleVideo.video_thumb})` }}>
                                                <a className="play-button-link" style={{ backgroundImage: `url(${assetUrl('assets/img/play_button_blue.png')})` }} href="#"></a>
                                            </div>
                                        }

                                        {
                                            !business.hide_video_request_email_copy && !currentProject.vr_example_video_id && trans && <p>{trans['easy-to-use']}</p>
                                        }
                                        <span className="btn preview-button" style={{ backgroundColor: currentProject.button_color, color: buttonTextColor() }}>{currentProject.email_cta_text || (trans ? trans['record-video'] : '')}</span>

                                        {renderUnsubscribeText()}
                                    </div>
                                </div >
                            )
                        }
                    </div >
                )
            }
        </>
    );
};

EmailPreviewTemplate.propTypes = {
    displayFont: PropTypes.object,
    pageName: PropTypes.string,
    business: PropTypes.object,
    currentProject: PropTypes.object,
    emailLogo: PropTypes.string,
    emailMessage: PropTypes.string,
    ctaDesc: PropTypes.string,
    envelopeName: PropTypes.string,
    landingPage: PropTypes.object,
    recipients: PropTypes.array,
    recipientIndex: PropTypes.number,
    activeRecipient: PropTypes.object,
    trans: PropTypes.object,
    vrExampleVideo: PropTypes.object,
    envelopePath: PropTypes.string,
    withFieldsMerged: PropTypes.func,
};

export default EmailPreviewTemplate;
